import React from 'react'
import { history } from './../../helpers/history'
import Title from '../../components/typography/title.component'
import styled from 'styled-components'
import Button from '../../components/buttons/buttons.component'
import Container from '../../components/layout/container.component'
import AddressForm from './components/address-form.component'
import { breakpoints } from '../../constants'
import PasswordForm from './components/password-form.component'
import NewsletterForm from './components/newsletter-form.component'
import PersonalForm from './components/personal-form.component'
import ComplementaryForm from './components/complementary-form.component'
import AccordionSecondary from '../../components/accordion/accordion-secondary.component'
import { routes } from '../../constants/routes.constants'
import { facebookApp, googleApp } from '../../constants/social-login.constants'
import { connect } from 'react-redux'
import { UserService } from '../../services/user.service'
import { toastActions, userActions } from '../../actions'
import { RoleConstants } from '../../constants'
import { registerClient } from './services/register-client.service'
import { Link, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { FriendInviteService } from './../../services/friend-invite.service'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { Creators as AuthenticationCreators } from '../../ducks/authentication/authentication'

import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login'
import faceLogo from '../../../../client/assets/icons/facebook-logo.svg'
import { AuthenticationService } from '../../services/authentication.service'

const StyledRegister = styled.div`
	padding: 3rem 0;
`

const StyledStepFrom = styled.div`
	padding: 2rem 1rem 1rem;
`
const StyleSocialLogin = styled.div`
	.social-login-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 10px;

		button {
			width: 300px;
			margin-top: 10px;
		}

		@media screen and (max-width: ${breakpoints.MOBILE}px) {
			display: flex;
			width: 100%;
			button {
				height: 40px;
			}
		}
	}
	.custom-google-button {
		height: 56px;
		padding-left: 1.8rem !important;
		padding-right: 1.8rem !important;
	}

	.custom-facebook-button {
		font-size: 18px;
		height: 56px;
		border-radius: 5px;
		padding: 0 3.4rem;
		background-color: #1977f3;
		display: inline-flex;
		align-items: center;
		color: white;
		border: 1px solid transparent;
		font-weight: 500;
		font-family: Roboto, sans-serif;
		cursor: pointer;
	}

	.custom-facebook-button img {
		margin: 0 16px 0px 3px;
	}
`
class BaseForm extends React.PureComponent {
	handleSubmit = (values, actions) => {
		const { onSubmit } = this.props
		onSubmit && onSubmit(values)
	}

	handleClick = (isValid) => {
		const { onClick } = this.props
		onClick && onClick(isValid)
	}

	handleBack = () => {
		const { onBack } = this.props
		onBack && onBack()
	}

	handleChangeStep = () => {
		this.refs.form && this.refs.form.onEnter && this.refs.form.onEnter()
	}
}

const StyledPage = styled.div`
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 4.6rem;

	p {
		text-align: center;
	}

	.custom-word-break {
		display: none;
	}

	@media (max-width: 320px) {
		.custom-word-break {
			display: block;
		}
	}
`

class StepOnePersonalForm extends BaseForm {
	render() {
		return (
			<StyledStepFrom>
				<PersonalForm
					ref={'form'}
					onSubmit={this.handleSubmit}
					onClick={this.handleClick}
				/>
			</StyledStepFrom>
		)
	}
}

class StepTwoComplementaryForm extends BaseForm {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<StyledStepFrom>
				<ComplementaryForm
					ref={'form'}
					{...this.props}
					onSubmit={this.handleSubmit}
					onClick={this.handleClick}
					onBack={this.handleBack}
				/>
			</StyledStepFrom>
		)
	}
}

class StepThreeAddressForm extends BaseForm {
	render() {
		return (
			<StyledStepFrom>
				<AddressForm
					ref={'form'}
					onSubmit={this.handleSubmit}
					onClick={this.handleClick}
					onBack={this.handleBack}
					{...this.props}
				/>
			</StyledStepFrom>
		)
	}
}

class StepFourPasswordForm extends BaseForm {
	render() {
		return (
			<StyledStepFrom>
				<PasswordForm
					ref={'form'}
					onSubmit={this.handleSubmit}
					onClick={this.handleClick}
					onBack={this.handleBack}
				/>
			</StyledStepFrom>
		)
	}
}

class StepFifthNewsletterForm extends BaseForm {
	render() {
		return (
			<StyledStepFrom>
				<NewsletterForm
					ref={'form'}
					onSubmit={this.handleSubmit}
					onClick={this.handleClick}
					onBack={this.handleBack}
				/>
			</StyledStepFrom>
		)
	}
}

class RegisterPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.data = {}
		this.currentStep = 0
		this.state = {
			username: '',
			success: null,
			registerWithEmail: false,
		}
		FriendInviteService.setInviteHash()
	}

	async componentDidMount() {
		await this.redirectToIntialPageIfLogged()
	}

	async redirectToIntialPageIfLogged() {
		const { history, user } = this.props
		if (user) {
			const role = await UserService.getMostImportantRole(user.roles)
			switch (role) {
				case RoleConstants.Client:
					history.replace(`${routes.CLIENTE}/loja-muviflex`)
					break

				case RoleConstants.Admin:
					history.replace(`${routes.ADMIN}`)
					break

				case RoleConstants.Partner:
					history.replace(`${routes.PARCEIRO}`)
					break

				default:
					break
			}
		}
	}

	onChangeStep() {
		switch (this.currentStep) {
			case 0:
				this.refs.stepOne.handleChangeStep()
				break
			case 1:
				this.refs.stepTwo.handleChangeStep()
				break
			case 2:
				this.refs.stepThree.handleChangeStep()
				break
			case 3:
				this.refs.stepFour.handleChangeStep()
				break
			case 4:
				this.refs.stepFifth.handleChangeStep()
				break
			default:
				this.sendForm()
				break
		}
	}

	goToNextStep = (nextStep) => {
		if (nextStep === undefined) this.currentStep++
		else this.currentStep = nextStep

		this.refs.steps.openJustTheItem(this.currentStep)
		this.onChangeStep()
	}

	goToBackStep = () => {
		this.currentStep--
		this.refs.steps.openJustTheItem(this.currentStep)
		this.onChangeStep()
	}

	checkStep = (message) => (isValid) => {
		const { toastError } = this.props
		if (!isValid) {
			toastError({
				message,
			})
		}
		return isValid
	}

	handleSubmitStepOne = () => {
		this.goToNextStep(1)
	}

	handleSubmitStepTwo = () => {
		this.goToNextStep(2)
	}

	handleSubmitStepThree = () => {
		this.goToNextStep(3)
	}

	handleSubmitStepFour = () => {
		this.goToNextStep(4)
	}

	handleSubmitStepFifth = () => {
		this.goToNextStep(5)
	}

	setRegisterWithEmail = () => {
		this.setState({ registerWithEmail: true })
	}

	handleResponseError = (data) => {
		const { hideLoading, toastError, toastCloseCurrent } = this.props
		this.goToNextStep(3)
		data && data.errors && data.errors[0]
			? toastError({
					message:
						data.errors[0] ===
						'Já existe um usuário cadastrado com os dados informados'
							? () => (
									<span>
										Já existe um usuário cadastrado com os dados
										informados.
										<br />
										<Link
											style={{ color: 'white ' }}
											to={routes.ENTRAR}
											onClick={toastCloseCurrent}>
											Clique aqui
										</Link>{' '}
										para entrar
									</span>
							  )
							: data.errors[0],
			  })
			: toastError({
					message:
						'Não foi possível efetuar o cadastro, por favor tente novamente mais tarde',
			  })

		hideLoading()
	}

	setDataToSend() {
		const { stepOne, stepTwo, stepThree, stepFour, stepFifth } = this.refs

		const { newsletter } = this.props

		const { name, cpf, rg, email } = stepOne.refs.form.refs.form.state.values
		this.data.name = name.trim()
		this.data.cpf = cpf
		this.data.rg = rg
		this.data.email = email

		const { phone, gender, source, birthday, rideApp, othersource } =
			stepTwo.refs.form.refs.form.state.values
		this.data.phone = phone
		this.data.gender = gender
		this.data.source = source
		this.data.birthday = birthday
		this.data.rideApp = rideApp
		this.data.othersource = othersource

		const { city, state } = stepThree.refs.form.refs.form.state.values
		this.data.city = city
		this.data.state = state

		this.data.password = stepFour.refs.form.passwordRef.current.value

		this.data.newsletter = newsletter
		this.data.inviteHash = FriendInviteService.getInviteHash()
	}

	sendForm = async () => {
		const { showLoading, hideLoading } = this.props
		this.setDataToSend()

		showLoading()

		registerClient(this.data)
			.then((result) => {
				if (result.success) {
					this.setState({ success: true }, () => {
						hideLoading()
						FriendInviteService.eraseInviteHash()
						setTimeout(window.scrollTo(0, 0), 0)
					})
				} else {
					this.handleResponseError(result)
				}
			})
			.catch(({ response }) =>
				this.handleResponseError(response && response.data)
			)
	}

	renderSuccess = () => (
		<StyledPage>
			<Container>
				<div>
					<Title>
						Quase lá
						<span className="bold">!</span>
					</Title>
					<p>
						Um e-mail de confirmação foi enviado para {this.data.email}.
						<br />
						Verifique sua caixa de emails (inclusive caixa de spams) para
						confirmar o cadastro no programa Muviflex
					</p>
				</div>
			</Container>
		</StyledPage>
	)

	handleSocialLoginResponse = (res) => {
		const { setProviderSignupData, userLogin } = this.props
		if (res.success) {
			if (res.data.shouldRedirectToSignUp) {
				setProviderSignupData(res.data)
				history.push(routes.LOGIN_SOCIAL_CADASTRO)
			} else if (!!res.data.accessToken) {
				userLogin(res.data)
				history.push('/')
			}
		}
	}

	onFacebookResponse = (providerResponse) => {
		const { hideLoading, showLoading, toastError } = this.props
		const message =
			'Não foi possível autenticar com o Facebook, tente novamente mais tarde.'

		if (providerResponse.status === 'unknown') return

		if (providerResponse.status && providerResponse.status !== 'unknown') {
			toastError({ message })
			return
		}

		showLoading()
		AuthenticationService.socialLogin('facebook', {
			AccessToken: providerResponse.accessToken,
		})
			.then((result) => {
				this.handleSocialLoginResponse(result)
				hideLoading()
			})
			.catch(() => {
				toastError({ message })
				hideLoading()
			})
	}

	onGoogleResponse = (providerResponse) => {
		const { hideLoading, showLoading, toastError } = this.props
		const message =
			'Não foi possível autenticar com o Google, tente novamente mais tarde.'

		showLoading()
		AuthenticationService.socialLogin('google', {
			TokenId: providerResponse.tokenId,
		})
			.then((result) => {
				this.handleSocialLoginResponse(result)
				hideLoading()
			})
			.catch(() => {
				toastError({ message })
				hideLoading()
			})
	}

	onGoogleFail = (errors) => {
		console.warn(errors)
	}

	renderLoginButtons = () => (
		<Container small>
			<Title>
				Cadastre-se e viaje <br /> muito mais com o <br />{' '}
				<span className="bold">Muviflex</span>
			</Title>
			<StyleSocialLogin>
				<div className="social-login-container">
					<GoogleLogin
						clientId={googleApp.clientId}
						buttonText="Entrar com o Google"
						onSuccess={this.onGoogleResponse}
						className="custom-google-button"
						onFailure={this.onGoogleFail}
						cookiePolicy={'single_host_origin'}
					/>
					<FacebookLogin
						appId={facebookApp.appId}
						fields="id,name,email"
						icon={<img src={faceLogo} alt="" />}
						cssClass="custom-facebook-button"
						callback={this.onFacebookResponse}
						textButton="Entrar com o Facebook"
					/>

					<Button
						primary
						className={`button button-modal`}
						type="button"
						onClick={this.setRegisterWithEmail}>
						CADASTRE-SE COM O E-MAIL
					</Button>
				</div>
			</StyleSocialLogin>
		</Container>
	)

	renderFormRegister = () => (
		<Container small>
			<Title>
				Cadastre-se e viaje <br /> muito mais com o <br />{' '}
				<span className="bold">Muviflex</span>
			</Title>
			<StyledRegister>
				<AccordionSecondary
					ref={'steps'}
					arrow={true}
					multiple={false}
					{...this.props}
					items={[
						{
							title: 'Dados Pessoais',
							onClick: () => (this.currentStep = 0),
							content: (
								<StepOnePersonalForm
									ref={'stepOne'}
									onSubmit={this.handleSubmitStepOne}
									onClick={this.checkStep(
										'Informe corretamente seus dados pessoais para prosseguir'
									)}
								/>
							),
						},
						{
							title: 'Dados complementares',
							onClick: () => (this.currentStep = 1),
							content: (
								<StepTwoComplementaryForm
									ref={'stepTwo'}
									{...this.props}
									onSubmit={this.handleSubmitStepTwo}
									onClick={this.checkStep(
										'Informe corretamente seus dados complementares para prosseguir'
									)}
									onBack={this.goToBackStep}
								/>
							),
						},
						{
							title: 'Endereço',
							onClick: () => (this.currentStep = 2),
							content: (
								<StepThreeAddressForm
									ref={'stepThree'}
									onSubmit={this.handleSubmitStepThree}
									onClick={this.checkStep(
										'Informe corretamente seu endereço para prosseguir'
									)}
									onBack={this.goToBackStep}
									{...this.props}
								/>
							),
						},
						{
							title: 'Senha',
							onClick: () => (this.currentStep = 3),
							content: (
								<StepFourPasswordForm
									ref={'stepFour'}
									onSubmit={this.handleSubmitStepFour}
									onClick={this.checkStep(
										'Senha informada não atende aos critérios de segurança'
									)}
									onBack={this.goToBackStep}
								/>
							),
						},
						{
							title: 'Termos e condições de uso',
							onClick: () => (this.currentStep = 4),
							content: (
								<StepFifthNewsletterForm
									ref={'stepFifth'}
									onSubmit={this.handleSubmitStepFifth}
									onBack={this.goToBackStep}
								/>
							),
						},
					]}
				/>
			</StyledRegister>
		</Container>
	)

	render() {
		const { success, registerWithEmail } = this.state
		if (success) return this.renderSuccess()

		if (!registerWithEmail) return this.renderLoginButtons()

		if (!success && registerWithEmail) return this.renderFormRegister()
	}
}

const mapStateToProps = ({ toast, user, newsletterOption }) => ({
	toast,
	user,
	newsletter: newsletterOption.newsletter,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			toastError: toastActions.danger,
			toastCloseCurrent: toastActions.closeCurrent,
			userLogin: (user) => dispatch(userActions.login(user)),
			setProviderSignupData: (data) =>
				dispatch(AuthenticationCreators.setProviderSignupData(data)),
		},
		dispatch
	)

const connectedRegisterPageComponent = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(RegisterPageComponent)
)

export { connectedRegisterPageComponent as ModuleRootComponent }
